import React from "react";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { Input } from "antd";

import { responsive } from "../../utils/style";

import ImageHeight from "../../assets/images/nutstatcalkiddiary_height.svg";
import ImageWeight from "../../assets/images/nutstatcalkiddiary_weight.svg";
import Footer from "./Footer";

const NutStat = (props) => {
  return (
    <Container>
      <Background isModal={props.isStudent}>
        <Topic>วิธีเช็กภาวะโภชนาการ</Topic>
        <Paragraph align="left" indent="1">
          คำอธิบายวิธีการเช็กภาวะโภชนาการของเด็ก ให้นำข้อมูล น้ำหนัก และส่วนสูง
          แล้วไปยังเว็บไซต์{" "}
          <a href="https://nutstatcal.kiddiary.in.th/" target="_blank">
            https://nutstatcal.kiddiary.in.th/
          </a>{" "}
          กรอกน้ำหนักและส่วนสูงในหน้าเว็บ แล้วกดผลประเมินได้ทันที
          ส่วนผู้เข้าแข่งขันก็นำผลประเมินมากรอกในหน้ากรอกข้อมูลโภชนาการต่อไป
        </Paragraph>
        <Paragraph align="left" indent="1">
          ในเว็บ https://nutstatcal.kiddiary.in.th/
        </Paragraph>
        <GroupInput>
          <li>
            <Label>อายุ</Label>
          </li>
          <Input disabled />
          <li>
            <Label>วันเกิด</Label>
          </li>
          <Input disabled />
        </GroupInput>
        <GroupInput>
          <Label>วันที่ชั่งน้ำหนัก</Label>
          <br />
          <Input disabled />
        </GroupInput>
        <GroupInlineInput>
          <Label>เพศ</Label>
          <Input disabled placeholder="ชาย" />
          <Input disabled placeholder="หญิง" />
        </GroupInlineInput>
        <GroupInlineInput>
          <Label>ส่วนสูง</Label>
          <Input disabled />
          <Label>เซนติเมตร</Label>
        </GroupInlineInput>
        <GroupInlineInput>
          <Label>น้ำหนัก</Label>
          <Input disabled />
          <Label>กิโลกรัม</Label>
        </GroupInlineInput>
        {/* <GroupInlineInput>
          <Label>น้ำหนัก</Label>
          <Input disabled />
          <Label>%IBW</Label>
        </GroupInlineInput> */}
        <GroupInlineInput>
          <Label>กด</Label>
          <CustomButton>ประเมิน</CustomButton>
        </GroupInlineInput>
        <GroupResult>
          <Label>ผล ส่วนสูงตามเกณฑ์อายุ</Label>
          <Image src={ImageHeight} />
        </GroupResult>
        <GroupResult>
          <Label>ผล น้ำหนักตามเกณฑ์ส่วนสูง</Label>
          <Image src={ImageWeight} />
        </GroupResult>
        <Paragraph align="left">
          แล้วนำ 5 รายการนี้ คือ น้ำหนัก ส่วนสูง
          ผลประเมินความสูงและน้ำหนักตัวมากรอกข้อมูลภาวะโภชนาการในเว็บแอปพลิเคชันเณรกล้า
          โภชนาดี
        </Paragraph>
        <Paragraph align="left">
          หากไม่สามารถเปิดเว็บไซต์ดังกล่าวได้ &nbsp;
          <Label>วิธีที่ 2</Label> ที่จะประเมินภาวะโภชนาการได้ด้วยตนเอง
          โดยมีข้อมูล น้ำหนัก ส่วนสูง อายุ และเพศ แล้ว
          ให้ไปที่ลิงค์ของของสำนักโภชนาการ กรมอนามัย
          กราฟแสดงเกณฑ์อ้างอิงการเจริญเติบโตของเด็กอายุ 6 - 19
          ปีน้ำหนักตามเกณฑ์ส่วนสูงของ เพศชาย{" "}
          <a
            href="https://nutrition2.anamai.moph.go.th/web-upload/6x22caac0452648c8dd1f534819ba2f16c/tinymce/files/kidchart/M-6-19_2.pdf"
            target="_blank"
          >
            “คลิก”
          </a>{" "}
          และ กราฟแสดงเกณฑ์ อ้างอิงการเจริญเติบโตของเด็กอายุ 6 - 19 ปี
          ส่วนสูงตามเกณฑ์อายุของเพศชาย{" "}
          <a
            href="https://nutrition2.anamai.moph.go.th/web-upload/6x22caac0452648c8dd1f534819ba2f16c/tinymce/files/กราฟแสดงเกณฑ์อ้างอิงการเจริญเติบโต%206-19%20ปี%20(1).pdf"
            target="_blank"
          >
            “คลิก”
          </a>{" "}
          เมื่อพบแล้วนำข้อมูล น้ำหนัก ส่วนสูงและอายุ เข้าไประบุจุดตัดในกราฟ
          ก็จะสามารถระบุสถานะทางโภชนาการได้
          {/* ส่วนการคำนวณ %IBW หรือ % น้ำหนักตัว
          เทียบกับผู้ที่สมส่วน ให้ใช้กราฟแสดงเกณฑ์อ้างอิง
          การเจริญเติบโตของเด็กอายุ 6 - 19 ปี น้ำหนักตามเกณฑ์ส่วนสูง
          เอาข้อมูลส่วนสูงที่มี ลากขึ้นไปตรงๆ พบเส้นกราฟที่ชื่อว่า Median
          (ดูทางขวาสุดของกราฟ) แล้วลากเส้นไปทางซ้ายไปพบแกนตั้ง
          จะพบค่าน้ำหนักที่สมส่วนของความสูงนั้นๆ แล้วเอาค่าน้ำหนักตัวที่มี
          หารน้ำหนักที่สมส่วน คูณด้วย 100 จะได้ค่า %IBW */}
        </Paragraph>
        <>
          <RuleParagraph align="left">
            โดยบันทึกข้อมูลได้ไม่เกิน 2 ครั้ง
          </RuleParagraph>
          <RemarkParagraph align="left">
            <Label> หมายเหตุวิธีเช็กภาวะโภชนาการ</Label>
            {` `}
            <br />
            วิธีการวัดส่วนสูง
            <ol>
              <li> ยืนตรง ฝ่าเท้าชิดกัน หัวเข่าตรง เท้าตรง</li>
              <li>แขนแนบลำตัว</li>
              <li> ส้นเท้า ก้น และไหล่สัมผัสกับผนังของเครื่องวัดส่วนสูง</li>
              <li>หายใจเข้าลึก</li>
              <li>อ่านค่า โดยมีไม้แนวระนาบทาบศีรษะ ตามองตรง</li>
              <li>จดค่าส่วนสูงอย่างละเอียด</li>
            </ol>
            วิธีการชั่งน้ำหนัก
            <ol>
              <li>ควรชั่งเวลาใกล้เคียงกันทุกครั้ง</li>
              <li>ปัสสาวะให้เรียบร้อยก่อนชั่ง</li>
              <li>
                เมื่อจะขึ้นชั่ง ให้ถอดรองเท้า ถุงเท้า ปลดจีวร อังสะ
                สัมภาระส่วนตัวที่มีน้ำหนักมาก เช่น โทรศัพท์ พวงกุญแจ
              </li>
              <li>จดค่าน้ำหนักอย่างละเอียด</li>
            </ol>
          </RemarkParagraph>
        </>
        {props.isStudent && <Footer />}
      </Background>
    </Container>
  );
};

export default NutStat;

const Container = styled.div`
  font-family: Noto Sans Thai, Noto Sans;
  background-color: #fffbeb;

  input {
    border-radius: 4px;
    max-width: 400px;
  }

  li {
    list-style-type: disc;
  }

  ${responsive.mobile(css`
    input {
      max-width: none;
    }
  `)}
`;
const Background = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1144px;
  background-color: white;
  padding: ${(props) => (props.isModal ? "0 24px" : "40px 116px 116px 80px")};
  margin: auto;

  ${responsive.tablet(css`
    padding: 24px 32px;
    max-width: unset;
  `)}

  ${responsive.mobile(css`
    padding: 24px 16px;
  `)}
`;
const Topic = styled.h5`
  font-weight: 700;
  font-size: 28px;
  line-height: 34px;
  text-align: center;
  color: #058459;
  margin-bottom: 24px;

  ${responsive.mobile(css`
    font-size: 18px;
    line-height: 26px;
    margin-bottom: 18px;
  `)}
`;
const Paragraph = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: ${(props) => props.fontSize || "18"}px;
  line-height: 26px;
  text-align: ${(props) => props.align || "center"};
  text-indent: ${(props) => props.indent || "0"}em;
  color: #0d0f11;
  margin-bottom: 1em;

  a {
    font-weight: bold;
    text-decoration: underline;
  }
`;
const Label = styled.label`
  font-weight: bold;
  font-size: 18px;
`;
const GroupInput = styled.div`
  margin-bottom: 12px;
  input {
    text-align: center;
  }
`;
const GroupInlineInput = styled(GroupInput)`
  display: flex;
  align-items: center;

  > input,
  label,
  button {
    width: 100px;
    margin-right: 15px;
  }
`;
const GroupResult = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 10px;
`;
const CustomButton = styled.div`
  background: #16af7b;
  border-radius: 100px;
  padding: 8px 24px;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  letter-spacing: -0.02em;
  color: #ffffff;
  height: 35px;
  width: 98px;
`;
const Image = styled.img`
  margin-top: 8px;
  width: 100%;
  max-width: 748.8px;
`;
const RuleParagraph = styled(Paragraph)`
  li {
    text-indent: 1em;

    > p {
      margin: 0px;
      display: inline;
    }

    ${responsive.mobile(css`
      > p {
        text-indent: 2.3em;
        display: block;
      }
    `)}
  }
`;
const RemarkParagraph = styled(Paragraph)`
  > ol > li {
    list-style-type: decimal;
  }
`;
